import React from 'react';
import { Bell, Mail, LogOut } from 'lucide-react';

interface AppSettingsTabProps {
    onLogout: () => void;
}

const AppSettingsTab: React.FC<AppSettingsTabProps> = ({ onLogout }) => {
    return (
        <div className="space-y-8">
            <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">Uygulama Ayarları</h3>
                <p className="text-gray-600">
                    Bildirimler ve otomatik işlemler için ayarlarınızı yönetin
                </p>
            </div>

            <div className="space-y-6">
                <div className="flex items-center justify-between p-6 bg-gray-50 rounded-xl border border-gray-200">
                    <div className="flex items-center space-x-4">
                        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                            <Bell className="h-6 w-6 text-blue-600" />
                        </div>
                        <div>
                            <h4 className="font-semibold text-gray-900">Email Bildirimleri</h4>
                            <p className="text-sm text-gray-600">Önemli güncellemeler için email bildirimleri alın</p>
                        </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" className="sr-only peer" defaultChecked />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600"></div>
                    </label>
                </div>

                <div className="flex items-center justify-between p-6 bg-gray-50 rounded-xl border border-gray-200">
                    <div className="flex items-center space-x-4">
                        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                            <Mail className="h-6 w-6 text-green-600" />
                        </div>
                        <div>
                            <h4 className="font-semibold text-gray-900">Otomatik Email Tarama</h4>
                            <p className="text-sm text-gray-600">Email hesaplarınızı otomatik olarak tarayın</p>
                        </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" className="sr-only peer" defaultChecked />
                        <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-purple-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600"></div>
                    </label>
                </div>

                <div className="pt-6 border-t border-gray-200">
                    <button
                        onClick={onLogout}
                        className="flex items-center px-6 py-3 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition-colors"
                    >
                        <LogOut className="h-4 w-4 mr-2" />
                        Çıkış Yap
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AppSettingsTab;
